import React from 'react'
export const tick = {
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6476 0.23805C14.0684 0.595736 14.1196 1.22683 13.7619 1.64764L5.26194 11.6476C5.07356 11.8692 4.79803 11.9979 4.50717 11.9999C4.21631 12.002 3.93896 11.8774 3.74743 11.6585L0.247436 7.65848C-0.116245 7.24285 -0.0741274 6.61108 0.341508 6.2474C0.757144 5.88372 1.38891 5.92584 1.75259 6.34147L4.48903 9.46884L12.238 0.352341C12.5957 -0.0684662 13.2268 -0.119636 13.6476 0.23805Z"
      fill="currentColor"
    />
  ),
  viewBox: '0 0 14 12',
}
